// Weeks in a row with at least one workout (Codex's review of the client's Stats, task 017, M3). The tile
// said "week streak" but counted days in a row, so a planned rest day ended it; a programme of two to four
// sessions a week needs weeks. Weeks start on Monday, in the device's own time zone. This week counts once
// trained; until then the streak runs to last week, so a week in progress never breaks it.

// The Monday (local midnight) of the week a moment falls in, as a sortable key
export const weekKey = (when) => {
  const d = new Date(when);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  const sinceMonday = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - sinceMonday);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// The longest run of consecutive weeks with a workout, anywhere in the moments given
export const longestWeeksInARow = (moments) => {
  const keys = [...new Set((moments || []).map(weekKey).filter(Boolean))].sort();
  let best = 0;
  let run = 0;
  let previous = null;
  for (const key of keys) {
    if (previous) {
      const next = new Date(`${previous}T12:00:00`);
      next.setDate(next.getDate() + 7);
      run = weekKey(next) === key ? run + 1 : 1;
    } else {
      run = 1;
    }
    best = Math.max(best, run);
    previous = key;
  }
  return best;
};

export const weeksInARow = (moments, now = new Date()) => {
  const trained = new Set((moments || []).map(weekKey).filter(Boolean));
  const week = new Date(now);
  let count = 0;
  if (!trained.has(weekKey(week))) week.setDate(week.getDate() - 7);
  while (trained.has(weekKey(week))) {
    count += 1;
    week.setDate(week.getDate() - 7);
  }
  return count;
};
